import React from "react";
import PropTypes from "prop-types";
import withIntl from "../../utils/withIntl";
import { days, WeekHours } from "./WeekHours";
import { DayHour, hourToMinutes } from "./DayHour";
import { Grid, IconButton, Typography } from "@material-ui/core";
import { Edit } from "@material-ui/icons";
import { useDialog } from "../Dialogs/DialogProvider";
import UpdateOpeningHourDialog from "./UpdateOpeningHourDialog";
import { createMuiTheme, makeStyles, ThemeProvider } from "@material-ui/core/styles";

export function getOpeningHoursOfObject(object) {
  let openingHoursDays = {};
  days.forEach((day) => {
    let parsedOpeningHours = JSON.parse(object[day]);

    let dayHours = Object.keys(parsedOpeningHours).map((openingHour) => {
      return new DayHour(openingHour, parsedOpeningHours[openingHour]);
    });
    dayHours.sort((a, b) => {
      return a.openingHour.localeCompare(b.openingHour);
    });

    openingHoursDays[day] = dayHours;
  });

  //// Fix overlapping times
  days.forEach((day, index) => {
    let dayRanges = openingHoursDays[day];
    let previousDayRanges = openingHoursDays[days[(index + 7 - 1) % 7]];

    if (dayRanges.length > 0 && previousDayRanges.length > 0) {
      if (
        !dayRanges[0].isClosed() &&
        dayRanges[0].openingHour === "00:00" &&
        !previousDayRanges[previousDayRanges.length - 1].isClosed() &&
        previousDayRanges[previousDayRanges.length - 1].closingHour === "24:00"
      ) {
        if (
          hourToMinutes(dayRanges[0].closingHour) <
          hourToMinutes(previousDayRanges[previousDayRanges.length - 1].openingHour)
        ) {
          previousDayRanges[previousDayRanges.length - 1].closingHour = dayRanges[0].closingHour;
          dayRanges.splice(0, 1);
        }
      }
    }
  });

  return new WeekHours(openingHoursDays);
}

const useStyles = makeStyles(() => ({
  disabledTitle: { color: "lightgray" },
}));

function OpeningHours(props) {
  const classes = useStyles();
  const [weekOpenRanges, setWeekOpenRanges] = React.useState(getOpeningHoursOfObject(props.openingHours));
  const [openDialog, closeDialog] = useDialog();
  let theme;
  if (props.size === "small") {
    theme = createMuiTheme({
      typography: {
        fontSize: 12,
      },
    });
  } else {
    theme = createMuiTheme();
  }

  return (
    <ThemeProvider theme={theme}>
      <div>
        <Grid container alignItems={"flex-start"}>
          {days.map((day) => {
            return (
              <>
                <Grid item xs={5} container alignItems={"center"}>
                  <Typography classes={{ root: props.disabled && classes.disabledTitle }}>
                    {props.intl.formatMessage({ id: day })}
                  </Typography>
                </Grid>
                <Grid item xs={6} container alignItems={"flex-start"} style={{ flexDirection: "column" }}>
                  {weekOpenRanges[day].length === 0 && (
                    <Typography>{props.intl.formatMessage({ id: "closed" })}</Typography>
                  )}
                  {weekOpenRanges[day].map((openRange) => {
                    if (openRange.isClosed()) {
                      return (
                        <Typography classes={{ root: props.disabled && classes.disabledTitle }}>
                          {props.intl.formatMessage({ id: "closed" })}
                        </Typography>
                      );
                    } else {
                      return (
                        <div>
                          <Typography classes={{ root: props.disabled && classes.disabledTitle }}>
                            {openRange.openingHour}
                            {" - "}
                            {openRange.closingHour}
                          </Typography>
                        </div>
                      );
                    }
                  })}
                </Grid>
                {!props.disabled && (
                  <Grid item={1} alignItems={"flex-start"}>
                    <IconButton
                      size={"small"}
                      onClick={() => {
                        openDialog({
                          maxWidth: "sm",
                          fullWidth: true,
                          children: (
                            <UpdateOpeningHourDialog
                              day={day}
                              openingHourRanges={weekOpenRanges[day]}
                              onSave={(openingHourRanges, editDays) => {
                                let newWeekOpenRanges = Object.assign(new WeekHours(), weekOpenRanges);
                                editDays.forEach((checked, index) => {
                                  if (checked) {
                                    newWeekOpenRanges[days[index]] = openingHourRanges.map((range) => {
                                      if (range.openingHour.split(":")[0].length === 1) {
                                        range.openingHour = "0" + range.openingHour;
                                      }
                                      if (range.openingHour.split(":")[1].length === 1) {
                                        range.openingHour =
                                          range.openingHour.substr(0, 3) + "0" + range.openingHour.substr(3, 1);
                                      }

                                      if (range.closingHour.split(":")[0].length === 1) {
                                        range.closingHour = "0" + range.closingHour;
                                      }
                                      if (range.closingHour.split(":")[1].length === 1) {
                                        range.closingHour =
                                          range.closingHour.substr(0, 3) + "0" + range.closingHour.substr(3, 1);
                                      }

                                      return Object.assign(new DayHour(), range);
                                    });
                                  }
                                });

                                let newData = {};
                                let nextDayOverlap = null;

                                days.forEach((day) => {
                                  let newDay = {};

                                  if (nextDayOverlap) {
                                    newDay["00:00"] = nextDayOverlap;
                                    nextDayOverlap = null;
                                  }

                                  newWeekOpenRanges[day].forEach((range) => {
                                    if (hourToMinutes(range.closingHour) < hourToMinutes(range.openingHour)) {
                                      /// nextDay
                                      newDay[range.openingHour] = "24:00";
                                      nextDayOverlap = range.closingHour;
                                    } else {
                                      newDay[range.openingHour] = range.closingHour;
                                    }
                                  });

                                  newData[day] = JSON.stringify(newDay);
                                });

                                if (nextDayOverlap) {
                                  let monday = JSON.parse(newData[days[0]]);
                                  monday["00:00"] = nextDayOverlap;
                                  newData[days[0]] = JSON.stringify(monday);
                                }

                                let promise = props.onSave(newData);

                                if (promise) {
                                  promise.then(() => {
                                    setWeekOpenRanges(newWeekOpenRanges);
                                    closeDialog();
                                  });
                                } else {
                                  setWeekOpenRanges(newWeekOpenRanges);
                                  closeDialog();
                                }
                              }}
                            />
                          ),
                        });
                      }}
                    >
                      <Edit />
                    </IconButton>
                  </Grid>
                )}
              </>
            );
          })}
        </Grid>
      </div>
    </ThemeProvider>
  );
}

OpeningHours.propTypes = {
  openingHours: PropTypes.instanceOf(WeekHours).isRequired,
  onSave: PropTypes.func.isRequired,
};

export default withIntl(OpeningHours);
